const $ = jQuery.noConflict();
class Tables {
    constructor() {
        this.tables = $('table.tablepress');
    }
    init() {
        this.tabeShadow();
        this.toggleTablesShadow();
    }
    toggleTablesShadow() {
        function shadowFunc() {
            const el = $(this);
            if (el[0].scrollWidth + 1 > el.parent().width() + 1) {
                el.parent().parent().addClass('has-scroll');
            } else {
                el.parent().parent().removeClass('has-scroll');
            }
        }

        function makeShadowHeight() {
            $(this).height($(this).siblings('.tablepress-scroll-wrapper').find('table').height());
        }

        this.tables.each(shadowFunc);
        $('.table-shadow').each(makeShadowHeight);
    }
    tabeShadow() {
        this.tables.parent('.tablepress-scroll-wrapper').wrap('<div class="table-wrapper"></div>');
        $('.table-wrapper').append('<div class="table-shadow"></div>');
    }
}
export default new Tables();
